import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkWithHref } from '@angular/router';

@Component({
  selector: 'ling-terms-agree-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLinkWithHref],
  templateUrl: './terms-agree-dialog.component.html',
  styleUrls: ['./terms-agree-dialog.component.scss'],
})
export class TermsAgreeDialogComponent {}
